import React, { useState, useEffect, memo } from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";

function VolumeMeter() {
  const {
    microphone,
    isMic,
    __merchantId,
    __userId,
    appInsightTrack,
    isAndroidTablet,
    microphonePermission    
  } = useLiveStreamAppContext(); // Assuming microphone is the ID from context
  const [volumeLevel, setVolumeLevel] = useState(0);

  useEffect(() => {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    let stream;
    let mediaStreamSource;
    let analyser;

    const startVolumeDetection = async () => {
      if (!isMic || microphonePermission !== "granted") {
        setVolumeLevel(0);
        return;
      }
      try {
        // Get user media with the provided microphone ID
        stream = await navigator.mediaDevices.getUserMedia({
          audio: { deviceId: microphone ? { exact: microphone } : undefined },
        });
        mediaStreamSource = audioContext.createMediaStreamSource(stream);
        analyser = audioContext.createAnalyser();
        mediaStreamSource.connect(analyser);
        analyser.fftSize = 256;
        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);

        const detectVolume = () => {
          if (!isMic || microphonePermission !== "granted") {
            setVolumeLevel(0);
            return;
          }
          analyser.getByteFrequencyData(dataArray);
          const sum = dataArray.reduce((a, b) => a + b, 0);
          const volume = Math.round(sum / bufferLength);
          setVolumeLevel(volume);
          requestAnimationFrame(detectVolume);
        };

        detectVolume();
      } catch (err) {
        console.error("Error accessing microphone", err);
        appInsightTrack(
          __merchantId,
          __userId,
          "Volume Detection Error",
          "",
          err
        );
        setVolumeLevel(0);
      }
    };

    const stopVolumeDetection = () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      if (mediaStreamSource) mediaStreamSource.disconnect();
      if (analyser) analyser.disconnect();
      setVolumeLevel(0);
    };

    if (isMic && microphonePermission === "granted") {
      startVolumeDetection();
    } else {
      stopVolumeDetection();
    }

    return () => {
      stopVolumeDetection();
      audioContext.close();
    };
  }, [microphone, isMic, microphonePermission]);

  const generateBars = (level) => {
    const numBars = isAndroidTablet ? 33 : 23;
    return Array.from({ length: numBars }, (_, i) =>
      i < numBars * (level / 100) ? "on" : ""
    );
  };

  const bars = generateBars(volumeLevel);

  return (
    <div className="field-group mb1 microphone-bar">
      <div className="label-and-field">
        <div className="micbars">
          {bars.map((className, index) => (
            <div key={index} className={isMic ? microphonePermission !== "granted"?"": className : ""}></div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(VolumeMeter);
